<div class="modal-overlay" *ngIf="isOpen" (click)="cancel()">
  <div class="modal-dialog modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content shadow-lg">

      <div class="modal-header bg-light">
        <h5 class="modal-title">
          <i class="bi bi-calendar-range me-2"></i>Romaneio de Entregas
        </h5>
        <button type="button" class="btn-close" (click)="cancel()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-3">Selecione o período desejado para gerar o romaneio:</p>

        <div class="mb-3">
          <label for="dataInicio" class="form-label fw-medium">Data de Início</label>
          <input
            type="date"
            id="dataInicio"
            class="form-control"
            [(ngModel)]="dataInicio"
            required>
        </div>

        <div class="mb-3">
          <label for="dataFim" class="form-label fw-medium">Data de Fim</label>
          <input
            type="date"
            id="dataFim"
            class="form-control"
            [(ngModel)]="dataFim"
            required>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
        <button type="button" class="btn btn-primary px-4" (click)="submit()">
          <i class="bi bi-file-earmark-text me-2"></i>Gerar Romaneio
        </button>
      </div>

    </div>
  </div>
</div>
